import React from "react";
import { PushpinFilled } from "@/utils/antdIcon";
import styles from "./index.module.less";

function TopIcon({ style, className }: { style?: any; className?: any }) {
  return (
    <div className={className} style={{ ...style }}>
      <div className={styles["content"]}>
        <div className={styles["pushpin_bg"]} />
        <PushpinFilled className={styles["pushpin"]} />
      </div>
    </div>
  );
}

export default TopIcon;
